import { Base, base } from "./base"

export type ObjectFits = Base

export const objectFits: ObjectFits = {
  ...base,
}
